/** Whole-złoty price ("15 zł"); minor units only when the amount has them ("15,50 zł"). */
export function formatPriceMinor(priceMinor: number, currency: string, locale: string): string {
    const hasMinorUnits = priceMinor % 100 !== 0
    return new Intl.NumberFormat(locale, {
        currency: currency || 'PLN',
        maximumFractionDigits: hasMinorUnits ? 2 : 0,
        minimumFractionDigits: hasMinorUnits ? 2 : 0,
        style: 'currency',
    }).formatToParts(priceMinor / 100).map(part => part.type === 'currency' && (!currency || currency === 'PLN') ? 'zł' : part.value).join('').replace(/[\u00a0\u202f]/g, ' ')
}
